"use strict";exports.MHID_PREFIX="CAD";
//# sourceMappingURL=MhidPrefix.cjs.map
